import * as types from "../actions/actionTypes";
const initialState = {
  is_fetched: false,
  loading: true,
  data: [],
  contact: {},
  last_item: "",
  fav_loading:0
};

const Contact = (state = initialState, action) => {
  let data;
  switch (action.type) {
    case types.CONTACT_LIST_REQUEST:
      return { ...state, loading: true };
    case types.CONTACT_LIST_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false,
        is_fetched: true
      };
    case types.CONTACT_LIST_FAILURE:
      return { ...state, loading: false };

    case types.CONTACT_ALL_REQUEST:
      return { ...state, loading: true };
    case types.CONTACT_ALL_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false,
        is_fetched: true
      };
    case types.CONTACT_ALL_FAILURE:
      return { ...state, loading: false };

    case types.CONTACT_SHOW_REQUEST:
      return { ...state, contact: {}, loading: true };
    case types.CONTACT_SHOW_SUCCESS:
      return {
        ...state,
        contact: action.payLoad,
        loading: false,
        is_fetched: true
      };
    case types.CONTACT_SHOW_FAILURE:
      return { ...state, loading: false };

    case types.CONTACT_STORE_REQUEST:
      return { ...state, loading: true };
    case types.CONTACT_STORE_SUCCESS:
      state.data.push(action.payLoad);
      return {
        ...state,
        last_item: action.payLoad,
        loading: false,
        storeStatus: true
      };
    case types.CONTACT_STORE_FAILURE:
      return { ...state, loading: false, storeStatus: false };
    case types.CONTACT_CLEAR_LAST_ITEM:
      return { ...state, last_item: "", loading: false };

    case types.CONTACT_UPDATE_REQUEST:
      return { ...state, loading: true, storeStatus: false };
    case types.CONTACT_UPDATE_SUCCESS:
      data = [];
      const contact = {
        ...action.payLoad,
        wage_rates: state.contact.wage_rates
      };
      if (state.data.length) {
        data = state.data.map(item =>
          item.id === Number(action.payLoad.id) ? contact : item
        );
      }
      return {
        ...state,
        data: data,
        contact: contact,
        loading: false,
        is_fetched: true,
        storeStatus: true
      };
    case types.CONTACT_UPDATE_FAILURE:
      return { ...state, loading: false, storeStatus: false };

    case types.CONTACT_ADD_FAVORITE_REQUEST:
      return { ...state, fav_loading: action.id };
    case types.CONTACT_ADD_FAVORITE_SUCCESS:
      data = state.data.map(item =>
        item.id === Number(action.payLoad.id) ? action.payLoad : item
      );
      return { ...state, data: data, fav_loading: 0 ,is_fetched:false};
    case types.CONTACT_ADD_FAVORITE_FAILURE:
      return { ...state, fav_loading: 0 };

    case types.CONTACT_REMOVE_REQUEST:
      return { ...state, loading: true };
    case types.CONTACT_REMOVE_SUCCESS:
      data = state.data.filter(item => item.id !== Number(action.payLoad.id));
      return { ...state, data: data, loading: false };
    case types.CONTACT_REMOVE_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default Contact;
